<template>
  <b-card
    no-body
  >
    <b-card-body
      title="Statistik"
      class="statistics-body"
    >
      <b-row>
        <b-col
          v-for="item in statisticsItems"
          :key="item.title"
          md="4"
          sm="6"
          class="mb-2 mb-md-0"
          :class="item.customClass"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                :variant="item.color"
              >
                <feather-icon
                  size="24"
                  :icon="item.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ item.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ item.subtitle }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: ['mitra', 'customer', 'orderselesai', 'orderbatal', 'ordertertunda', 'mitrapria', 'mitrawanita', 'customerpria', 'customerwanita'],
  data() {
    return {
      statisticsItems: [
        {
          icon: 'UserIcon',
          color: 'light-warning',
          title: this.mitrapria,
          subtitle: 'Mitra Pria',
          customClass: 'mb-2 mb-xl-0 mt-2',
        },
        {
          icon: 'UserIcon',
          color: 'light-warning',
          title: this.mitrawanita,
          subtitle: 'Mitra Wanita',
          customClass: 'mb-2 mb-xl-0 mt-2',
        },
        {
          icon: 'UserIcon',
          color: 'light-warning',
          title: this.mitra,
          subtitle: 'Total Mitra',
          customClass: 'mb-2 mb-xl-0 mt-2',
        },
        {
          icon: 'UsersIcon',
          color: 'light-info',
          title: this.customerpria,
          subtitle: 'Customer Pria',
          customClass: 'mb-2 mb-xl-0 mt-2',
        },
        {
          icon: 'UsersIcon',
          color: 'light-info',
          title: this.customerwanita,
          subtitle: 'Customer Wanita',
          customClass: 'mb-2 mb-xl-0 mt-2',
        },
        {
          icon: 'UsersIcon',
          color: 'light-info',
          title: this.customer,
          subtitle: 'Total Customer',
          customClass: 'mb-2 mb-xl-0 mt-2',
        },
        {
          icon: 'BoxIcon',
          color: 'light-success',
          title: this.orderselesai,
          subtitle: 'Pesanan Selesai',
          customClass: 'mb-2 mb-sm-0 mt-2',
        },
        {
          icon: 'BoxIcon',
          color: 'light-warning',
          title: this.ordertertunda,
          subtitle: 'Pesanan Terabaikan',
          customClass: 'mb-2 mb-xl-0 mt-2',
        },
        {
          icon: 'BoxIcon',
          color: 'light-danger',
          title: this.orderbatal,
          subtitle: 'Pesanan Batal',
          customClass: 'mb-2 mb-xl-0 mt-2',
        },
      ],
    }
  },
}
</script>
